import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonApp, IonBackButton, IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent,
  IonInput, IonItem, IonLabel, IonList, IonListHeader, IonLoading, IonMenu, IonMenuButton, IonMenuToggle, IonNote, IonRefresher, IonRefresherContent,
  IonSearchbar, IonSpinner, IonSplitPane, IonTextarea, IonTitle, IonToolbar, IonRouterOutlet, IonModal, IonRow, IonDatetime, IonDatetimeButton, 
  IonAccordionGroup, IonAccordion, IonToggle, IonRadioGroup, IonRadio, IonBadge, IonPopover, IonActionSheet } from '@ionic/angular/standalone';
import { PipesModule } from '../pipes/pipes.module';

const Modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  IonApp, 
  IonSplitPane, 
  IonMenu, 
  IonContent, 
  IonList, 
  IonListHeader, 
  IonNote, 
  IonMenuToggle, 
  IonItem, 
  IonIcon, 
  IonLabel,
  IonRouterOutlet,
  IonHeader,
  IonMenuButton,
  IonToolbar,
  IonTitle,
  IonSpinner,
  IonButton,
  IonSearchbar,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
  IonLoading,
  IonInput,
  IonTextarea,
  IonFooter,
  IonButtons,
  IonBackButton,
  IonModal,
  IonRow,
  IonDatetime,
  IonDatetimeButton,
  IonAccordionGroup,
  IonAccordion,
  IonToggle,
  IonRadioGroup,
  IonRadio,
  IonBadge,
  IonPopover,
  IonActionSheet,
  PipesModule
]

@NgModule({
  declarations: [],
  imports: [
    ...Modules
  ],
  exports: [
    ...Modules
  ],
})
export class IonicComponentsModule { }
